// extracted by mini-css-extract-plugin
export default {"table":"CalculationTable_table__efSng","addRelation":"CalculationTable_addRelation__MF0mW"};